import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid, Border, Breakpoints, Color, Type } from '../app/StyleGuide';

const AlertBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${Color.Secondary._05};
  border-radius: ${Border.radius};
  box-shadow: inset 0 0 0 1px rgba(81, 144, 197, 0.15);
  margin: ${Grid._5} 0;
  padding: ${Grid._4};
  color: ${Type.Color.dark};

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    flex-direction: row;
    padding: ${Grid._4} ${Grid._6};
  }
`;

const AlertContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 0%;
  min-width: 0;

  i {
    flex: 0 0 auto;
    color: ${Color.Blue._50};
    font-size: ${Type.Scale._6};
    margin-right: ${Grid._5};
  }
`;

const AlertInfo = styled.div`
  flex: 1 1 0%;
  min-width: 0;

  h4 {
    text-transform: capitalize;
  }
  p {
    color: ${Type.Color.medium};
  }
`;

const AlertActions = styled.div`
  flex: 0 0 auto;

  @media screen and (max-width: ${Breakpoints.screen_sm}) {
    width: 100%;
    margin-top: ${Grid._3};

    button {
      width: 100%;
    }
  }
`;

const Link = styled.a`
  display: flex;
  margin-top: ${Grid._3};
`;

type Props = {
  title?: string;
  description: string;
  link?: Array<{ id: string; url: string; target?: string; text: string }>;
  iconClass?: string;
  children?: React.ReactNode;
};

export default function HelpAndInfoBox({
  title,
  description,
  link,
  iconClass = 'fas fa-info-circle',
  children,
  ...props
}: Props) {
  return (
    <AlertBox {...props}>
      <AlertContent>
        <i className={iconClass}></i>
        <AlertInfo>
          <h4>{title}</h4>
          <p>{description}</p>
          {link &&
            link.map(l => (
              <Link
                key={l.id}
                data-qa-hook="helpInfoBoxURL"
                href={l.url}
                target={l.target ? l.target : '_blank'}
                rel="noreferrer"
              >
                {l.text}
              </Link>
            ))}
        </AlertInfo>
      </AlertContent>
      {children && <AlertActions>{children}</AlertActions>}
    </AlertBox>
  );
}
